// Copyright (c) 2021, 37.78 Tecnologia Ltda. All rights reserved.

import _3778 from "./themes/3778";
import segurosUnimed from "./themes/segurosUnimed";
import lively from "./themes/lively";
import materialui from "./themes/materialui";

const themes = {
  3778: _3778,
  segurosUnimed,
  lively,
  materialui,
};

const variants = {
  get: (key) => themes[key],
  keys: Object.keys(themes),
  default: "3778",
};

export default variants;
